var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckBox48Line = function SvgIconCheckBox48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.045 14.8h-.025a1.32 1.32 0 0 1-.955-.43L8.13 12.28l1.245-1.155 1.68 1.81 3.6-3.585 1.2 1.205-3.865 3.85c-.255.255-.59.39-.945.39v.005Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 19.1h-8.9c-1.46 0-2.65-1.19-2.65-2.65v-8.9c0-1.46 1.19-2.65 2.65-2.65h8.9c1.46 0 2.65 1.19 2.65 2.65v8.9c0 1.46-1.19 2.65-2.65 2.65ZM7.55 6.6a.95.95 0 0 0-.95.95v8.9c0 .525.425.95.95.95h8.9a.95.95 0 0 0 .95-.95v-8.9a.95.95 0 0 0-.95-.95h-8.9Z",
    fill: "current"
  })));
};
export default SvgIconCheckBox48Line;